<div class="container login">
    <div class="row">
        <div class="col-md-12">
            <div class="box mt40 mb40 static">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="static-content">
                            <h2>{{title}}</h2>
                            {{text}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>